import React from 'react';
import ProfileImage from '../img/profileimage.JPG'
import './profileinfo.scss'

const ProfileInfo = () => {
	return (
		<>
			<section className="mainProfileInfo" id="ProfileInfo">
				<div className="subProfileInfo">
					<div className="ProfileInfo-content">
						<div className="ProfileInfo-text">
							<div className="ProfileInfo-text-one">Hello,</div>
							<div className="ProfileInfo-text-two">I make apps that are simple, fast, and fun to use.</div>
							<div className="ProfileInfo-text-three">I specialize in Responsive Web Design and serve as the bridge between concept and reality. My expertise spans both UI/UX Design and the precise execution of Visual Development.</div>
						</div>
					</div>
					
					<div className="ProfileInfo-content">
						<div className="ProfileInfo-text ProfileInfo-text-img">
							<img src={ProfileImage} alt="Profile Image" />
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default ProfileInfo;